<template>
  <div class="p-2" id="app">
    <courses-list />
  </div>
</template>

<script>
  import CoursesList from '@/components/CoursesList.vue'
  // import vSelect from 'vue-select'
  // import $ from 'jquery'
  // import "bootstrap"
  export default {
      name: "CoursesListApp",
      components: {
        CoursesList,
      },
      mounted(){
      },
      computed: {
      },
      created() {
      },
      methods: {
      },
      props:{
      },
      data(){
          return {}
      },
      watch: {
      },
  }
</script>
<!--<style scoped lang="css"  src="./assets/bootstrap.min.css"></style>-->
<style scoped>
  body {
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
  }
</style>
